import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as PlusIcon } from '@pkg/assets/icons/v2/plus.svg';
import { DepLinkButton } from '@pkg/components/deprecated';
import useScrollDirection, { ScrollDirections } from '@pkg/hooks/helpers/useScrollDirection';

import './MobileBottomNavigation.scss';

export const MobileBottomNavigation = () => {
    const { t } = useTranslation(['dashboard', 'artifacts']);
    const scrollDir = useScrollDirection();

    const className = useMemo(() => {
        let classes = 'mobile-bottom-navigation mobile-bottom-navigation--new-navigation';
        if (scrollDir === ScrollDirections.Down) classes += ' mobile-bottom-navigation--hide';
        //didn't reset back to just 'mobile-bottom-navigation' in case we need to throw more classes in here later
        if (scrollDir === ScrollDirections.Up) classes.replace(' mobile-bottom-navigation--hide', '');

        classes += ' mobile-bottom-navigation--artifact-not-visible';

        return classes;
    }, [scrollDir]);

    return (
        <div className={className}>
            <DepLinkButton
                to="/create"
                state={{ enableGoBack: true }}
                variant="primary"
                glow
                size="small"
                classes="mobile-bottom-navigation__yat-btn"
            >
                <PlusIcon className="mobile-bottom-navigation__create-cta-icon" aria-hidden="true" />
                {t('create_yats')}
            </DepLinkButton>
        </div>
    );
};
